import { useCallback, useRef, useState } from 'react';
import { useTranslations } from 'next-intl';
import classNames from 'classnames';
import { Button, ButtonSize, ButtonType } from '@nx-frontend/shared/ui/button';
import { webnotesThemeColors, webnotesThemeStyle } from '@nx-frontend/shared/themes/webnotes';

interface PaywallOrderSummaryCouponProps {
  error: string | null;
  onApply: (coupon: string) => void;
}

export const PaywallOrderSummaryCoupon = (props: PaywallOrderSummaryCouponProps) => {
  const { error, onApply } = props;
  const [showForm, setShowForm] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const t = useTranslations('features');

  const handleShowForm = useCallback(() => {
    setShowForm(true);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  }, [setShowForm]);

  if (showForm) {
    return (
      <>
        <div className="flex gap-2">
          <input
            ref={inputRef}
            className={classNames(
              'border w-full border-neutral-200 rounded-lg focus:border-cyan-700 outline-none px-2 text-sm text-neutral-800',
              {
                '!border-red-500': Boolean(error),
              }
            )}
            placeholder={t('paywall.coupon_optional')}
          />
          <Button
            type={ButtonType.FLAT}
            size={ButtonSize.SM}
            onClick={() => onApply(inputRef.current?.value ?? '')}
            themeColors={webnotesThemeColors}
            themeStyle={webnotesThemeStyle}
            className="!p-2.5 h-[30px]"
          >
            {t('paywall.apply')}
          </Button>
        </div>
        {error ? <div className="text-xs text-red-500 mt-2">{t('paywall.code_is_wrong_error')}</div> : null}
      </>
    );
  }

  return (
    <button className="text-cyan-900 text-sm font-semibold underline" onClick={handleShowForm}>
      + {t('paywall.add_a_coupon')}
    </button>
  );
};
